const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicences(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M58.59,0c2.69.56,4.54,2.79,4.54,5.64v25.05c-5.94-1.7-12.15-.39-16.87,3.55-2.27,1.92-4.02,4.21-5.25,6.92-2.52,5.52-2.16,11.75.87,16.95v10.64s-28.27,0-28.27,0c-3.08-.03-5.48-2.4-5.48-5.49V5.65C8.12,2.79,9.96.55,12.66,0h45.94ZM44.45,17.49c1.51,0,2.46-1.33,2.42-2.56-.04-1.31-1.07-2.43-2.5-2.43h-21.23c-1.49,0-2.54,1.2-2.51,2.57.03,1.27,1.08,2.43,2.51,2.43h21.31ZM44.45,27.49c1.51,0,2.46-1.33,2.42-2.56-.04-1.31-1.07-2.43-2.5-2.43h-21.23c-1.49,0-2.54,1.2-2.51,2.57.03,1.27,1.08,2.43,2.51,2.43h21.31ZM35.71,37.49c1.49,0,2.45-1.33,2.41-2.56-.04-1.31-1.08-2.43-2.5-2.43h-12.5c-1.47,0-2.53,1.2-2.5,2.57.03,1.27,1.09,2.43,2.5,2.43h12.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,35.09c7.66-.88,14.38,4.67,15.22,12.11.86,7.52-4.6,14.36-12.12,15.21-7.47.84-14.27-4.52-15.19-11.99-.92-7.46,4.4-14.45,12.09-15.33ZM51.75,52.24l3.8,2.53c1.09.73,2.64.41,3.37-.69l4.95-7.4c.82-1.23.63-2.68-.54-3.55-1.07-.79-2.7-.61-3.51.6l-3.65,5.45-1.72-1.13c-1.16-.76-2.69-.36-3.41.73s-.51,2.66.7,3.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,79.67l-7.51-4.29-7.31,4.18c-.89.51-1.82.61-2.71.09s-1.24-1.37-1.24-2.48v-13.44c6.71,5.01,15.81,5.01,22.5,0v13.59c0,1.01-.41,1.79-1.14,2.26-.8.51-1.75.56-2.6.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicences);
export default __webpack_public_path__ + "static/media/licences.bb89544e1e4947e8cdac5eca57a6b6bc.svg";
export { ForwardRef as ReactComponent };